var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91895 26.0355V33.9376C7.91895 35.0372 8.82343 35.9313 9.93569 35.9313H17.3671",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2939 7.36763H75.2645",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2939 12.684H75.2645",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6689 73.0254V81",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.491 5.22897C27.2298 5.22897 25.0664 5.65187 23.0863 6.42517C22.6707 7.07764 22.4385 7.83885 22.4385 8.67256C22.4385 15.016 27.6454 20.1391 34.0623 20.6828H46.7983C45.9061 11.9953 38.4991 5.22897 29.491 5.22897Z",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7885 45.3438H38.3041C43.0588 45.3438 46.9089 41.5377 46.8967 36.8375V22.4227C46.8967 12.9257 39.1108 5.22897 29.4916 5.22897C19.8845 5.22897 12.0864 12.9257 12.0986 22.4348V36.8496C12.0986 41.5377 15.9488 45.3438 20.7034 45.3438H22.2557",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0322 30.1678H46.8969",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0986 30.1678H16.9755",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.877 20.6707C16.8892 20.6707 16.9015 20.6707 16.9137 20.6707H12.2568",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2656 38.2753C24.0402 40.7644 27.487 42.1056 29.516 42.1418C33.3172 42.0572 42.0809 37.4416 42.0809 29.177V20.6707",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6474 13.9648C23.6474 17.6621 20.6161 20.6587 16.876 20.6707L16.9249 29.2012C16.9249 31.0982 17.3893 32.8018 18.1471 34.3001",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5282 38.2753H19.6392C18.3802 38.2753 17.3535 37.2604 17.3535 36.0158C17.3535 34.7713 18.3802 33.7564 19.6392 33.7564H24.5282C25.7872 33.7564 26.8139 34.7713 26.8139 36.0158C26.8139 37.2604 25.7872 38.2753 24.5282 38.2753Z",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8967 30.1678C49.2068 30.1678 51.0769 28.3191 51.0769 26.0355V22.3382C51.0769 10.5695 41.3965 1 29.4916 1C17.5866 1 15.3621 5.25313 13.4065 7.18638C11.4508 9.11962 7.90625 16.6351 7.90625 22.3382V26.0234C7.90625 28.307 9.77632 30.1557 12.0864 30.1557",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6393 1H60.2803C57.1268 1 54.5723 3.5253 54.5723 6.64265V13.4211C54.5723 16.0914 56.4546 18.3267 58.9724 18.9187C59.7425 19.1 60.2803 19.7887 60.2803 20.5741V25.528C60.2803 26.0234 60.9281 26.2288 61.2214 25.8301L65.6827 19.7645C66.0127 19.3175 66.5261 19.0637 67.0761 19.0637H76.292C79.4455 19.0637 82 16.5384 82 13.4211V6.64265C82 3.5253 79.4455 1 76.292 1H62.6393Z",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5306 50.5756L40.0503 48.5457C38.0091 47.9899 36.6035 46.1654 36.6035 44.0751V39.2057",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4262 39.2299V44.0992C22.4262 46.1895 21.0205 48.014 18.9916 48.5698C16.9382 49.1377 14.2003 49.8748 11.4746 50.6239",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9798 56.194C55.8064 53.9708 53.7285 52.2671 51.1618 51.5663L47.5194 50.5756C46.2605 52.7263 44.6104 54.6233 42.667 56.194",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6401 60.8097C30.2612 60.8338 29.8823 60.8459 29.4911 60.8459C21.803 60.8459 15.0928 56.7378 11.4749 50.6118C10.2526 50.9501 9.03032 51.2764 7.86916 51.6026C3.81122 52.7142 1 56.3632 1 60.5318V78.1001C1.01222 79.695 2.33227 80.9879 3.94567 80.9879L29.4667 80.9637",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.274 80.9879H29.7603C28.4769 80.9879 27.4502 79.9609 27.4502 78.7043C27.4502 77.4477 28.4891 76.4206 29.7603 76.4206H68.274C69.5574 76.4206 70.5841 77.4477 70.5841 78.7043C70.5841 79.9609 69.5452 80.9879 68.274 80.9879Z",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6396 70.6692V76.4085",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4055 76.4206V58.4415C67.4055 57.209 66.3911 56.2062 65.1443 56.2062H32.9008C31.6541 56.2062 30.6396 57.209 30.6396 58.4415V70.6813",
    stroke: "#00BFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.81f1f34d27518faa0652ed104f027b67.svg";
export { ForwardRef as ReactComponent };